import { DATE_FORMAT } from '../constants/date';
import { CustomDatePipe } from '../pipes/custom-date.pipe';
import { RowMapper } from '../utils/row-mapper';
import { EntityType } from './entitlements/entity';

export class Intervention {
  activitynotes: string;
  interventionid: number;
  careplanid: number;
  goalid: number;
  description: string = null;
  notes = '';
  assignedtoentity: string;
  assignedentitytype: EntityType = null;
  interventiondt: Date;
  status: InterventionStatus = null;
  statusDescription: string;
  memberid: string;
  orgid: number;
  orglevel: number;
  addedby: string;
  adddt: string;
  modifieddttm: Date;
  modifiedby: string;
  followupdt: Date;
  tasktype: string;
  otherTaskType: string;
  priority: string;
  firstName: string;
  lastName: string;
  interventionStartDate: Date;
  interventionEndDate: Date;
  reasonId: number = null;
  reason: string;
  activityNotesCount: number;
  deleteReason: string;
  deleteFlag: boolean;
  intervtitleid: number = null;
  intervtitleother: string = null;
  intervtitletext: string = null;
  goaltitletext: string;
  steptype: string = null;
  dtcomplete: Date;
  frequency: number;
  interval: ActionStepInterval = null;
  assignedtoentityrole: string = null;
  heartfailureintervention: string = null;
  caseReviewId: string;
}

export enum InterventionStatus {
  COMPLETE = 'COMPLETE',
  INCOMPLETE_NO_LONGER_APPLICABLE = 'INCOMPLETE_NO_LONGER_APPLICABLE',
  INCOMPLETE_PATIENT_REFUSAL = 'INCOMPLETE_PATIENT_REFUSAL',
  INPROGRESS = 'INPROGRESS'
}

export enum InterventionStepType {
  CARE_MANAGER_INTERVENTIONS = 'CARE_MANAGER_INTERVENTIONS',
  CHRONIC_KIDNEY_DISEASE_INTERVENTION = 'CHRONIC_KIDNEY_DISEASE_INTERVENTION',
  HEART_FAILURE_INTERVENTION = 'HEART_FAILURE_INTERVENTION',
  PREVENTIVE_CARE_GAPS = 'PREVENTIVE_CARE_GAPS'
}

export enum ActionStepInterval {
  ONE_TIME = 'ONE_TIME',
  PER_DAY = 'PER_DAY',
  PER_WEEK = 'PER_WEEK',
  PER_MONTH = 'PER_MONTH'
}

export class InterventionRow {
  interventionid: number;
  addedby: string;
  careplanid: number;
  goalid: number;
  description: string;
  intervtitletext: string;
  intervtitleother: string;
  goaltitletext: string;
  status: string;
  statusDescription: string;
  reason: string;
  reasonId: number;
  interventionEndDate: Date;
  interventionEndDateFormatted: string;
  interventiondt: Date;
  dtcomplete: Date;
  interventionDtFormatted: string;
  tasktype: string;
  otherTaskType: string;
  patientName: string;
  firstName: string;
  lastName: string;
  memberid: string;
  assignedtoentity: string;
  fullName: string;
  followupdt: Date;
  followupDtFormatted: string;
  assignedentitytype: EntityType;
  notes = '';
  activityNotesCount = 0;
  deleteReason: string;
  deleteFlag: boolean;
  assignedtoentityrole: string;
  activitynotes: string;
  orgid: number;
  orglevel: number;
  adddt: string;
  modifieddttm: Date;
  modifiedby: string;
  priority: string;
  interventionStartDate: Date;
  intervtitleid: number = null;
  steptype: string = null;
  frequency: number;
  interval: ActionStepInterval = null;
  heartfailureintervention: string = null;
  sourceObject: Intervention;
}

export class InterventionRowMapper implements RowMapper<Intervention, InterventionRow> {
  constructor(private datePipe: CustomDatePipe) {}

  mapRows(values: Intervention[]): InterventionRow[] {
    if (values && values.length) {
      return values.map((value) => {
        return this.mapRow(value);
      });
    }

    return [];
  }

  mapRow(value: Intervention) {
    const row = new InterventionRow();
    row.interventionid = value.interventionid;
    row.careplanid = value.careplanid;
    row.goalid = value.goalid;
    row.description = value.description;
    row.intervtitletext = value.intervtitletext;
    row.intervtitleother = value.intervtitleother;
    row.goaltitletext = value.goaltitletext;
    row.status = value.status;
    row.statusDescription = value.statusDescription;
    row.reason = value.reason;
    row.reasonId = value.reasonId;
    row.tasktype = value.tasktype;
    row.otherTaskType = value.otherTaskType;
    row.interventiondt = value.interventiondt;
    row.interventionDtFormatted = this.datePipe.transform(value.interventiondt, DATE_FORMAT, 'UTC') || 'UNK';
    row.dtcomplete = value.dtcomplete;
    row.interventionEndDate = value.interventionEndDate;
    row.interventionEndDateFormatted = this.datePipe.transform(value.interventionEndDate, DATE_FORMAT);
    row.followupdt = value.followupdt;
    row.followupDtFormatted = this.datePipe.transform(value.followupdt, DATE_FORMAT, 'UTC');
    row.firstName = value.firstName;
    row.lastName = value.lastName;
    row.assignedtoentity = value.assignedtoentity;
    row.addedby = value.addedby;
    row.memberid = value.memberid;
    row.assignedentitytype = value.assignedentitytype;
    row.notes = value.notes;
    row.activityNotesCount = value.activityNotesCount;
    row.assignedtoentityrole = value.assignedtoentityrole;

    row.activitynotes = value.activitynotes;
    row.orgid = value.orgid;
    row.orglevel = value.orglevel;
    row.adddt = value.adddt;
    row.modifieddttm = value.modifieddttm;
    row.modifiedby = value.modifiedby;
    row.priority = value.priority;
    row.interventionStartDate = value.interventionStartDate;
    row.intervtitleid = value.intervtitleid;
    row.steptype = value.steptype;
    row.frequency = value.frequency;
    row.interval = value.interval;
    row.heartfailureintervention = value.heartfailureintervention;

    row.sourceObject = value;

    return row;
  }
}
